export const CUISINES = {
  mexicaine: { label: "Mexicain", color: "#C2410C", bg: "#FCEBDD" },
  mediterraneenne: { label: "Méditerranéen", color: "#0E7490", bg: "#DDF1F5" },
  asiatique: { label: "Asiatique", color: "#BE123C", bg: "#FBE0E6" },
  italienne: { label: "Italien", color: "#15803D", bg: "#DEF3E4" },
  francaise: { label: "Français", color: "#4A4E7A", bg: "#E4E5F0" },
  indienne: { label: "Indien", color: "#B45309", bg: "#FBEEDA" },
  moyen_orient: { label: "Moyen-Orient", color: "#7C3AED", bg: "#EDE4FB" },
  americaine: { label: "Américain", color: "#B91C1C", bg: "#FBE1E1" },
  autre: { label: "Autre", color: "#8C7B75", bg: "#F0EBE8" },
};

export const cuisineOf = (id) => CUISINES[id] || null;
